import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a726531"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-bespoke-pulmonary-manifestations" }
const _hoisted_2 = { class: "hd-bespoke-pulmonary-manifestations__top" }
const _hoisted_3 = { class: "hd-bespoke-pulmonary-manifestations__toggle" }
const _hoisted_4 = { class: "hd-bespoke-pulmonary-manifestations__container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lyra_asset = _resolveComponent("lyra-asset")!
  const _component_base_toggle = _resolveComponent("base-toggle")!
  const _component_base_image_svg = _resolveComponent("base-image-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_lyra_asset, {
      class: "hd-title",
      "asset-key": `${_ctx.endpointId}.title`
    }, null, 8, ["asset-key"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_base_toggle, {
          items: _ctx.toggleItems,
          onToggleUpdated: _ctx.updateToggleActive
        }, null, 8, ["items", "onToggleUpdated"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(["hd-bespoke-pulmonary-manifestations__boxes", `hd-bespoke-pulmonary-manifestations__boxes--${_ctx.toggleActive}`])
      }, [
        _createVNode(_component_base_image_svg, {
          source: require(`@/applications/covid-hub/ui/assets/bespoke/body-boxes-${_ctx.toggleActive}.png`),
          "is-image": true
        }, null, 8, ["source"])
      ], 2)
    ])
  ]))
}